export const buildKey = (query, isbn = "library") => `q:${query}:${isbn}`;
